export const PlaceOfServiceList = [
    {
        code: "01",
        display: "Pharmacy",
        system: "https://www.cms.gov/Medicare/Coding/place-of-service-codes/Place_of_Service_Code_Set"
    },
    {
        code: "11",
        display: "Office",
        system: "https://www.cms.gov/Medicare/Coding/place-of-service-codes/Place_of_Service_Code_Set"
    },
    {
        code: "12",
        display: "Home",
        system: "https://www.cms.gov/Medicare/Coding/place-of-service-codes/Place_of_Service_Code_Set"
    },
    {
        code: "21",
        display: "Inpatient Hospital",
        system: "https://www.cms.gov/Medicare/Coding/place-of-service-codes/Place_of_Service_Code_Set"
    },
    {
        code: "22",
        display: "On Campus-Outpatient Hospital",
        system: "https://www.cms.gov/Medicare/Coding/place-of-service-codes/Place_of_Service_Code_Set"
    },
    {
        code: "99",
        display: "Other Place of Service",
        system: "https://www.cms.gov/Medicare/Coding/place-of-service-codes/Place_of_Service_Code_Set"
    }
];